import { render, staticRenderFns } from "./CobManagementList.vue?vue&type=template&id=db278268&"
import script from "./CobManagementList.vue?vue&type=script&lang=js&"
export * from "./CobManagementList.vue?vue&type=script&lang=js&"
import style0 from "./CobManagementList.vue?vue&type=style&index=0&id=db278268&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports